import { toRaw } from 'vue'

function capitalizeFirstCharacter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/** Deep clone that safely handles Vue reactive proxies via toRaw + structuredClone. */
export function cloneRaw<T>(value: T): T {
  return structuredClone(toRaw(value))
}

export function normalizeEmail(email: string): string {
  return email.toLowerCase()
}

export function normalizeUsername(username: string): string {
  return username.toLowerCase()
}

/** Prevents HTML injection; escapes &, <, >, ", and '. */
export function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;')
}

/**
 * Escapes a string for use as a CSS string literal value (inside double quotes).
 * Also prevents `</style>` sequences that would break out of an inline `<style>` block.
 * ONLY safe when the result is placed inside a double-quoted CSS string ("...").
 * Do NOT use for CSS selectors, property names, or unquoted values.
 */
export function escapeCssString(s: string): string {
  return s
    .replace(/\\/g, '\\\\') // CSS backslash first
    .replace(/"/g, '\\"') // CSS double-quote delimiter
    .replace(/</g, '\\3c ') // prevents </style> injection
    .replace(/\r?\n/g, ' ') // CSS strings cannot contain unescaped newlines
}

export { capitalizeFirstCharacter }
